const equipments = {
    CARCASS:   'carcass',
    MACHINERY: 'machinery',
    TANK:      'tank',
};

const popupShowTime = 5000;

export default equipments;
export {popupShowTime};
